import posthog from 'posthog-js'

let isInitialized = false

export function usePostHog() {
  if (!isInitialized) {
    const apiKey = import.meta.env.VITE_POSTHOG_API_KEY
    const apiHost = import.meta.env.VITE_POSTHOG_API_HOST
    
    if (apiKey && apiHost) {
      posthog.init(apiKey, {
        api_host: apiHost,
        defaults: '2025-05-24',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        capture_pageview: 'history_change', // SPAの自動ページビュートラッキング
        capture_pageleave: 'if_capture_pageview', // ページ離脱時間の計測
      })
      isInitialized = true
    }
  }

  return { posthog }
}